import React from 'react'
import PropTypes from 'prop-types'

import { FormattedMessage } from 'sb-react-intl'

import FooterNav from 'components/layout/Footer/FooterView/ExceptMobile/FooterNav/FooterNav'
import FooterColumnTitle from 'components/layout/Footer/FooterView/ExceptMobile/FooterColumnTitle/FooterColumnTitle'


const FooterAboutUs = ({ title, nav }) => (
  <div>
    <FooterColumnTitle>
      <FormattedMessage {...title} />
    </FooterColumnTitle>
    <FooterNav items={nav} ariaLabel="About us" />
  </div>
)

FooterAboutUs.propTypes = {
  title: PropTypes.object.isRequired,
  nav: PropTypes.array,
}

export default FooterAboutUs
